import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=6d752410&scoped=true&"
import script from "./js/Create.js?vue&type=script&lang=js&"
export * from "./js/Create.js?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&id=6d752410&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d752410",
  null
  
)

export default component.exports